const tagPriceMapper = [
  { value: 'Pajarito', label: 'Pajarito', price: 17000 },
  { value: 'Cantagallo', label: 'Cantagallo', price: 17000 },
  { value: 'Vespucio', label: 'Vespucio', price: 17000 },
  { value: 'Antofagasta', label: 'Antofagasta', price: 17000 },
  { value: 'Bilbao', label: 'Bilbao', price: 17000 },
  { value: 'Calama', label: 'Calama', price: 17000 },
  { value: 'Castro', label: 'Castro', price: 17000 },
  { value: 'Chicureo', label: 'Chicureo', price: 17000 },
  { value: 'Chillan', label: 'Chillan', price: 17000 },
  { value: 'Concepcion', label: 'Concepcion', price: 17000 },
  { value: 'Coyhaique', label: 'Coyhaique', price: 17000 },
  { value: 'Curico', label: 'Curico', price: 17000 },
  { value: 'Iquique', label: 'Iquique', price: 17000 },
  { value: 'La Dehesa', label: 'La Dehesa', price: 17000 },
  { value: 'La Serena', label: 'La Serena', price: 17000 },
  { value: 'Llanquihue', label: 'Llanquihue', price: 17000 },
  { value: 'Los Angeles', label: 'Los Angeles', price: 17000 },
  { value: 'Osorno', label: 'Osorno', price: 17000 },
  { value: 'Placilla', label: 'Placilla', price: 17000 },
  { value: 'Punta Arenas', label: 'Punta Arenas', price: 17000 },
  { value: 'Quilicura', label: 'Quilicura', price: 17000 },
  { value: 'Rancagua', label: 'Rancagua', price: 17000 },
  { value: 'San Bernardo', label: 'San Bernardo', price: 17000 },
  { value: 'Talca', label: 'Talca', price: 17000 },
  { value: 'Temuco', label: 'Temuco', price: 17000 },
  { value: 'Valdivia', label: 'Valdivia', price: 17000 },
  { value: 'Arica', label: 'Arica', price: 17000 },
  { value: 'Linares', label: 'Linares', price: 17000 },
  { value: 'Copiapo', label: 'Copiapo', price: 17000 },
  { value: 'Santiago Norte', label: 'Santiago Norte', price: 17000 },
];

export default tagPriceMapper;
